<template>
  <div class="car-voice">
    <el-row :gutter="20">
		<!-- 数据列表区 -->
      <el-col :span="6"><div class="grid-content bg-purple boxShadow">

	  <el-table
	    :data="listData"
	    v-loading="listLoading"
	    border
	    highlight-current-row
	    style="width: 100%;align: center;height: 87%;">
	    <!-- @selection-change="handleSelectionChange"> -->
	    <el-table-column prop="id" label="车辆id"  width="200" align="center">
	    </el-table-column>
	    <el-table-column prop="operator" label="操作" align="center">
	      <template v-slot:="{row,$index}">
	        <el-button type="primary" plain size="mini" @click="carVoiceBtn(row)">
	         显示
	        </el-button>
	      </template>
	    </el-table-column>
	  </el-table>

	  <!-- 分页栏 -->
	  <pagination :total="totalCounts"
	   layout='sizes,prev, pager, next'
	     small :pager-count="5"
	    @pagination="handlePageChange">
	  </pagination>


	  </div></el-col>

	<!-- 雷达显示区 -->
      <el-col :span="18"><div class="grid-content bg-purple boxShadow">
			<div class="portlet-body flip-scroll" style="text-align:center;">
	  			<canvas id="voiceCanvas" width='1400px' height='700px' ref="voiceCanvas"></canvas>
	        </div>
	  </div></el-col>
    </el-row>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import {carListByParam} from '@/api/car'
import {getRecord} from '@/api/car'

export default {
  name: 'CarVoice',
  components: {
    Pagination
  },
  data(){
	  return {
	    listLoading: false,
	    listData: [],
	    totalCounts: 0,
	    listQuery: {
		  isRobot: '',
		  carIdStr: '',
	      pageIndex: 1,
	      pageSize: 10,
	      params: {},
	      fuzzySearch: true,
	    },
		carId:'',
		myCavans:'',
		// 背景图片缓存
		carImg:new Image(),
		voice0: new Image(),
		voice0_left: new Image(),
		voice0_down: new Image(),
		voice0_right: new Image(),
		voice1: new Image(),
		voice1_left: new Image(),
		voice1_down: new Image(),
		voice1_right: new Image(),
		voice2: new Image(),
		voice2_left: new Image(),
		voice2_down: new Image(),
		voice2_right: new Image(),
		voice3: new Image(),
		voice3_left: new Image(),
		voice3_down: new Image(),
		voice3_right: new Image(),
		voice4: new Image(),
		voice4_left: new Image(),
		voice4_down: new Image(),
		voice4_right: new Image(),
		voice5: new Image(),
		voice5_left: new Image(),
		voice5_down: new Image(),
		voice5_right: new Image(),
		carVoiceInterval:undefined,
	  }
  },
  methods:{
	 /**
	  * handleFilter 用于请求车辆数据
	  */
	 handleFilter() {
	   this.listLoading = true
	   this.listQuery.isRobot=null;
	   this.listQuery.carIdStr='';
	   // 对请求参数做转换
	   let newParams = Object.assign({}, this.listQuery.params)
	   carListByParam(this.listQuery, newParams).then(res => {
	     let data = res.pageData
	     this.totalCounts = data.totalCounts
	     // 对后端数据进行解析
	     this.listData = data.datas.map(item => {
	       return {
	         id: item.id,
	       }
	     })
	     this.listLoading = false
	   })
	 },
	 handlePageChange(data) {
	   this.listQuery.pageIndex = data.page
	   this.listQuery.pageSize = data.limit
	   this.handleFilter()
	 },
	 /**
	  * 显示按钮点击事件处理
	  * @param {Object} row
	  */
	 carVoiceBtn(row){
		 this.carId=row.id;
	 },
	 paintCar(carImg){
		 this.paintImg(this.myCavans,carImg,590,300,220,100);
	 },
	 paintImg(myCavans,img,x,y,width,height){
		let ctx=myCavans.getContext("2d");
		ctx.drawImage(img,x,y,width,height);
	},
	/**
	 * 初始化绘制信息
	 */
	drowCanvas(){
		let that=this
		this.carImg.onload = function(){
			that.paintCar(that.carImg);
		};
		this.carImg.src = require('assets/img/voice/car.png');
		this.voice0.onload = function(){};
		this.voice0.src = require('assets/img/voice/voice0.png');
		this.voice0_left.onload = function(){}
		this.voice0_left.src = require('assets/img/voice/voice0_left.png');
		this.voice0_down.onload = function(){}
		this.voice0_down.src = require('assets/img/voice/voice0_down.png');
		this.voice0_right.onload = function(){}
		this.voice0_right.src = require('assets/img/voice/voice0_right.png');

		this.voice1.onload = function(){};
		this.voice1.src = require('assets/img/voice/voice1.png');
		this.voice1_left.onload = function(){}
		this.voice1_left.src = require('assets/img/voice/voice1_left.png');
		this.voice1_down.onload = function(){}
		this.voice1_down.src = require('assets/img/voice/voice1_down.png');
		this.voice1_right.onload = function(){}
		this.voice1_right.src = require('assets/img/voice/voice1_right.png');

		this.voice2.onload = function(){};
		this.voice2.src = require('assets/img/voice/voice2.png');
		this.voice2_left.onload = function(){}
		this.voice2_left.src = require('assets/img/voice/voice2_left.png');
		this.voice2_down.onload = function(){}
		this.voice2_down.src = require('assets/img/voice/voice2_down.png');
		this.voice2_right.onload = function(){}
		this.voice2_right.src = require('assets/img/voice/voice2_right.png');

		this.voice3.onload = function(){};
		this.voice3.src = require('assets/img/voice/voice3.png');
		this.voice3_left.onload = function(){}
		this.voice3_left.src = require('assets/img/voice/voice3_left.png');
		this.voice3_down.onload = function(){}
		this.voice3_down.src = require('assets/img/voice/voice3_down.png');
		this.voice3_right.onload = function(){}
		this.voice3_right.src = require('assets/img/voice/voice3_right.png');

		this.voice4.onload = function(){};
		this.voice4.src = require('assets/img/voice/voice4.png');
		this.voice4_left.onload = function(){}
		this.voice4_left.src = require('assets/img/voice/voice4_left.png');
		this.voice4_down.onload = function(){}
		this.voice4_down.src = require('assets/img/voice/voice4_down.png');
		this.voice4_right.onload = function(){}
		this.voice4_right.src = require('assets/img/voice/voice4_right.png');

		this.voice5.onload = function(){};
		this.voice5.src = require('assets/img/voice/voice5.png');
		this.voice5_left.onload = function(){}
		this.voice5_left.src = require('assets/img/voice/voice5_left.png');
		this.voice5_down.onload = function(){}
		this.voice4_down.src = require('assets/img/voice/voice5_down.png');
		this.voice5_right.onload = function(){}
		this.voice5_right.src = require('assets/img/voice/voice5_right.png');

	},
	/**
	 * 绘制
	 * @param {Object} canvas
	 */
	paintByRecord(canvas){
		console.log(this.carId,"------------")
		getRecord(this.carId).then(res=>{
			console.log(this.carId,res.data[0])
			if(res.data[0]){
				if(res.data[0].ultrasonic_2>=0){
					this.paintImg(canvas,this.getImg(1,Math.ceil(res.data[0].ultrasonic_2/60)),290,170,300,260);
				}
				if(res.data[0].ultrasonic_1>= 0){
					this.paintImg(canvas,this.getImg(1,Math.ceil(res.data[0].ultrasonic_1/60)),290,260,300,260);
				}
				if(res.data[0].ultrasonic_3 >= 0){
					this.paintImg(canvas,this.getImg(2,Math.ceil(res.data[0].ultrasonic_3/60)),810,260,300,260);
				}
				if(res.data[0].ultrasonic_4 >= 0){
					this.paintImg(canvas,this.getImg(2,Math.ceil(res.data[0].ultrasonic_4/60)),810,170,300,260);
				}
				if(res.data[0].ultrasonic_5 >= 0){
					this.paintImg(canvas,this.getImg(3,Math.ceil(res.data[0].ultrasonic_5/60)),495,400,260,300);
				}
				if(res.data[0].ultrasonic_6 >= 0){
					this.paintImg(canvas,this.getImg(3,Math.ceil(res.data[0].ultrasonic_6/60)),645,400,260,300);
				}
				if(res.data[0].ultrasonic_7 >= 0){
					this.paintImg(canvas,this.getImg(4,Math.ceil(res.data[0].ultrasonic_7/60)),495,0,260,300);
				}
				if(res.data[0].ultrasonic_8 >= 0){
					this.paintImg(canvas,this.getImg(4,Math.ceil(res.data[0].ultrasonic_8/60)),645,0,260,300);
				}
			}else{

			}
		})
	},
	/**
	 * 获取图片
	 * @param {Object} dir
	 * @param {Object} index
	 */
	getImg(dir,index){
		if(dir == 1){
			// 左侧
			if(index == 0){
				return this.voice4_left;
			} else if(index == 1){
				return this.voice5_left;
			} else if(index == 2){
				return this.voice4_left;
			} else if(index == 3){
				return this.voice3_left;
			} else if(index == 4){
				return this.voice2_left;
			} else if(index >= 5 && index <= 7){
				return this.voice1_left;
			}else{
				return this.voice0_left;
			}
		} else if(dir == 2){
			// 右侧
			if(index == 0){
				return this.voice1_right;
			} else if(index == 1){
				return this.voice5_right;
			} else if(index == 2){
				return this.voice4_right;
			} else if(index == 3){
				return this.voice3_right;
			} else if(index == 4){
				return this.voice2_right;
			} else if(index >= 5 && index <= 7){
				return this.voice1_right;
			}else{
				return this.voice0_right;
			}
		} else if(dir == 3){
			// 下面
			if(index == 0){
				return this.voice3_down;
			} else if(index == 1){
				return this.voice5_down;
			} else if(index == 2){
				return this.voice4_down;
			} else if(index == 3){
				return this.voice3_down;
			} else if(index == 4){
				return this.voice2_down;
			} else if(index >= 5 && index <= 7){
				return this.voice1_down;
			}else{
				return this.voice0_down;
			}
		} else if(dir == 4){
			// 上面
			if(index == 0){
				return this.voice4;
			} else if(index == 1){
				return this.voice5;
			} else if(index == 2){
				return this.voice4;
			} else if(index == 3){
				return this.voice3;
			} else if(index == 4){
				return this.voice2;
			} else if(index >= 5 && index <= 7){
				return this.voice1;
			}else{
				return this.voice0;
			}
		}
	},
	checkLeave(){
	    clearInterval(this.carVoiceInterval);
		console.log("离开雷达管理页面")
	},
  },
  beforeDestroy(){
      this.checkLeave()
  },
  destroyed(){
       window.removeEventListener('beforeunload', this.checkLeave)
  },
  mounted() {
	this.carId= "432515341168414720";
	this.myCavans=this.$refs.voiceCanvas;
	this.drowCanvas();
	let that=this;
	this.carVoiceInterval=setInterval(function(){
		that.paintByRecord(that.myCavans);
	},1000);
	window.addEventListener('beforeunload', this.checkLeave);
  	this.handleFilter();
  }
}
</script>

<style>
.boxShadow{
	height: 700px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2), 0 0 6px rgba(0, 0, 0, 0.4);
}

</style>
